import { createAction, props } from "@ngrx/store";
import { IResponseRetrieveBolla } from "../../interfaces/response-retrieve-bolla";
import { IPayloadEliminaMagazzinoPickup, IResponseMagazzinoPickup } from "../../interfaces/response-magazzino-pickup";
import { IBollaPost, IBollaPostResponse } from "../../interfaces/bolla-post";
import { IMagazzinoContatoriResponse } from "../../interfaces/magazzino-contatori";
import { IParamsStampaScontrinoRitiro, IStampaScontrinoRitiroResponse } from "../../interfaces/stampa-scontrino-ritiro";
import { IAcquisisciBollaPayload, IAcquisisciBollaResponse, IAnnullaBolla } from "../../interfaces/acquisisci-bolla";

export const RETRIEVE_BOLLA = createAction(
  '[COURIER-ACTIVITIES] - retrieve bolla'
);

export const RETRIEVE_BOLLA_SUCCESS = createAction(
  '[COURIER-ACTIVITIES] - retrieve bolla success',
  props<{ responseRetrieveBolla: IResponseRetrieveBolla | null }>()
);

export const RETRIEVE_MAGAZZINO_PICKUP = createAction(
  '[COURIER-ACTIVITIES] - retrieve magazzino pickup'
);

export const RETRIEVE_MAGAZZINO_PICKUP_SUCCESS = createAction(
  '[COURIER-ACTIVITIES] - retrieve magazzino pickup success',
  props<{ responseMagazzinoPickup: IResponseMagazzinoPickup | null }>()
);

export const RETRIEVE_BOLLA_POST = createAction(
  '[COURIER-ACTIVITIES] - retrieve bolla post',
  props<{ payloadBollaPost: IBollaPost }>()
);

export const RETRIEVE_BOLLA_POST_SUCCESS = createAction(
  '[COURIER-ACTIVITIES] - retrieve bolla post success',
  props<{ responseRetrieveBollaPost: IBollaPostResponse | null }>()
);

export const RETRIEVE_MAGAZZINO_CONTATORI = createAction(
  '[COURIER-ACTIVITIES] - retrieve magazzino contatori',
);

export const RETRIEVE_MAGAZZINO_CONTATORI_SUCCESS = createAction(
  '[COURIER-ACTIVITIES] - retrieve magazzino contatori success',
  props<{ responseMagazzinoContatori: IMagazzinoContatoriResponse | null }>()
);

export const RETRIEVE_STAMPA_SCONTRINO_RITIRO = createAction(
  '[COURIER-ACTIVITIES] - retrieve stampa scontrino ritiro',
  props<{ params: IParamsStampaScontrinoRitiro }>()
);

export const RETRIEVE_STAMPA_SCONTRINO_RITIRO_SUCCESS = createAction(
  '[COURIER-ACTIVITIES] - retrieve stampa scontrino ritiro success',
  props<{ responseStampaScontrinoRitiro: IStampaScontrinoRitiroResponse | null }>()
);

export const RETRIEVE_ACQUISISCI_BOLLA = createAction(
  '[COURIER-ACTIVITIES] - retrieve acquisisci bolla',
  props<{ payload: IAcquisisciBollaPayload }>()
);

export const RETRIEVE_ACQUISISCI_BOLLA_SUCCESS = createAction(
  '[COURIER-ACTIVITIES] - retrieve acquisisci bolla success',
  props<{ responseAcquisisciBolla: IAcquisisciBollaResponse | null }>()
);

export const RETRIEVE_BOLLA_POST_NO_PALMARE = createAction(
  '[COURIER-ACTIVITIES] - retrieve bolla post no palmare',
  props<{ payload: IBollaPost }>()
);

export const RETRIEVE_BOLLA_POST_NO_PALMARE_SUCCESS = createAction(
  '[COURIER-ACTIVITIES] - retrieve bolla post no palmare success',
  props<{ responseBollaPostNoPalmare: IBollaPostResponse | null }>()
);

export const RETRIEVE_MAGAZZINO_PICKUP_DELETE = createAction(
  '[COURIER-ACTIVITIES] - retrieve magazzino pickup delete',
  props<{ payload: IPayloadEliminaMagazzinoPickup }>()
);

export const RETRIEVE_MAGAZZINO_PICKUP_DELETE_SUCCESS = createAction(
  '[COURIER-ACTIVITIES] - retrieve magazzino pickup delete success',
  props<{ responseDeleteMagazzinoPickup: IResponseMagazzinoPickup | null }>()
);

export const RETRIEVE_ANNULLA_BOLLA = createAction(
  '[COURIER-ACTIVITIES] - retrieve annulla bolla'
);

export const RETRIEVE_ANNULLA_BOLLA_SUCCESS = createAction(
  '[COURIER-ACTIVITIES] - retrieve annulla bolla success',
  props<{ responseAnnullaBolla: IAnnullaBolla | null }>()
);

export const RETRIEVE_CONSEGNA_SENZA_PALMARE = createAction(
  '[COURIER-ACTIVITIES] - retrieve consegna senza palmare'
);

export const RETRIEVE_CONSEGNA_SENZA_PALMARE_SUCCESS = createAction(
  '[COURIER-ACTIVITIES] - retrieve consegna senza palmare success',
  props<{ responseConsegnaSenzaPalmare: IAnnullaBolla | null }>()
);

